import { BoomGateArrowDownOutlineIcon } from './BoomGateArrowDownOutlineIcon';

/**
 * author: Michael Richins
 * id F0ED697E-DAA8-4530-8403-C614C8EBCE3B
 * name boom-gate-arrow-down-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/boom-gate-arrow-down-outline.svg
 * tags
 * - Transportation + Road 
 */
export const BarrierDownOutlineIcon = BoomGateArrowDownOutlineIcon;
export default BarrierDownOutlineIcon